export enum IsAgendamentos {
  SIM = 'true',
  NAO = 'false',
  DIRECT = 'direct'
}

export interface SectorType {
  setor_id?: number
  id?: number
  prefixo?: string
  prefixoPrioridade?: string
  descricao?: string
  botao?: boolean
  cor?: string
  corfonte?: string
  is_agendamentos?: IsAgendamentos
  ordem?: number
}
